import script from "./UserManualEvents.vue?vue&type=script&setup=true&lang=js"
export * from "./UserManualEvents.vue?vue&type=script&setup=true&lang=js"

import "./UserManualEvents.vue?vue&type=style&index=0&id=24936a74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24936a74"]])

export default __exports__